import React from "react";
import CustomTabsGrid from "components/CustomTabs/CustomTabsGrid.js";
import Trungtamdangkiem from "components/Danhmuc/Trungtamdangkiem/Trungtamdangkiem.js";
export default function Dmttdangkiem() {
  return (
    <div>
      <CustomTabsGrid
        headerColor="primary"
        tabs={[
          {
            tabName: "Trung tâm đăng kiểm",
            tabContent: <Trungtamdangkiem />,
          },
        ]}
      />
    </div>
  );
}
